import { Box, HStack, Text } from '@chakra-ui/react';

/** Wave 3 (C.3): applying is automatic on vote save, so this reports rather than gates. */
export function ApplyBar({ dirty, attendeesTagged }: {
  dirty: boolean
  attendeesTagged: number
}) {
  return (
    <Box position="sticky" bottom={0} bg="surface" borderTopWidth="1px" py={3} px={4}
      style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom, 0px))' }}>
      <HStack justify="space-between">
        <Text fontSize="sm" color={dirty ? 'orange.600' : 'gray.500'}>
          {dirty ? '⚠ Unsaved vote changes' : 'All changes saved'}
        </Text>
        <Text fontSize="sm" color="gray.600">
          {attendeesTagged} attendees tagged
        </Text>
      </HStack>
    </Box>
  );
}
